





























import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { Prompt } from "@/model/Model";
import { ScrollToTop } from "@/utils";

@Component
export default class ConfirmationPrompt extends Vue {
  @Prop() private prompt!: Prompt;
  @Prop() private confirmationAction!: () => void;

  @Emit("cancel-confirmation-prompt")
  private cancel() {
    return;
  }

  @Emit("confirm-confirmation-prompt")
  private confirm() {
    return;
  }
}
